import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor, handleSave } from "../withEditorProps";
import { withHandlers } from "recompose";
import { compose } from "redux";
export default compose(
  connectToEditor(
    ({ readOnly, sequenceData = {}, lastSavedId = "134%!@#%!@#%!@%" }) => {
      return {
        readOnly,
        sequenceData,
        hasBeenSaved: sequenceData.stateTrackingId === "initialLoadId" || sequenceData.stateTrackingId === lastSavedId
      };
    }
  ),
  withHandlers({ handleSave })
)(({
  toolbarItemProps,
  alwaysAllowSave,
  handleSave: handleSave2,
  readOnly,
  hasBeenSaved,
  onSave
}) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "saveTool", icon: "floppy-disk" }),
        onIconClick: handleSave2,
        disabled: alwaysAllowSave ? false : !onSave || hasBeenSaved || readOnly,
        tooltip: /* @__PURE__ */ jsxs("span", { children: [
          "Save ",
          /* @__PURE__ */ jsx("span", { style: { fontSize: 10 }, children: "(Cmd/Ctrl+S)" })
        ] }),
        ...toolbarItemProps
      }
    }
  );
});
